import { render, staticRenderFns } from "./AboutPageAvailableData.vue?vue&type=template&id=2f28f8fc&scoped=true"
import script from "./AboutPageAvailableData.vue?vue&type=script&lang=js"
export * from "./AboutPageAvailableData.vue?vue&type=script&lang=js"
import style0 from "./AboutPageAvailableData.vue?vue&type=style&index=0&id=2f28f8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28f8fc",
  null
  
)

export default component.exports